export interface RoofVizDiagnosticsSnapshot {
  mountedInstances: number;
  activeAnimationLoops: number;
  registeredListeners: number;
  rendererContexts: number;
}

const counters: RoofVizDiagnosticsSnapshot = {
  mountedInstances: 0,
  activeAnimationLoops: 0,
  registeredListeners: 0,
  rendererContexts: 0,
};

function adjust(key: keyof RoofVizDiagnosticsSnapshot, delta: 1 | -1): void {
  counters[key] = Math.max(0, counters[key] + delta);
}

export const roofVizDiagnostics = {
  mounted(delta: 1 | -1): void { adjust("mountedInstances", delta); },
  animationLoop(delta: 1 | -1): void { adjust("activeAnimationLoops", delta); },
  listener(delta: number): void {
    counters.registeredListeners = Math.max(0, counters.registeredListeners + delta);
  },
  renderer(delta: 1 | -1): void { adjust("rendererContexts", delta); },
  snapshot(): RoofVizDiagnosticsSnapshot { return { ...counters }; },
};
